<template>
  <div class="page-job">
    <main class="main-path">
      <section class="waiting">
        <h1>Waiting For You</h1>
        <h4>浩瀚宇宙中我们在等你</h4>
        <img
          class="illustration"
          src="https://assets.dinlab.cn/staticPage/img/job-placehold1.png"
          alt=""
        />
        <div class="para">
          <p>希望你在黎明之前尽快与我们会合，你面对的将是：<br /><br /></p>
          <p class="li">
            １　一个超赞的办公空间——全球创意者梦想的众创空间，南京西路wework；
          </p>
          <p class="li">
            ２　一个充满活力和激情的团队（伙伴都是知名互联网团队Uber、蚂蚁金服等成员）；
          </p>
          <p class="li">３　一份还不错的薪水；</p>
          <p class="li">
            ４　同各路国内外杰出商业设计师深度接触的机会；<br /><br />
          </p>
          <p>
            我们相信，我们不是去找一个陌生人。我们寻找的，是我们失联已久的小伙伴，可以和我们一同在这浩瀚宇宙中探索无限的队友。
          </p>
        </div>
      </section>
      <section class="hiring">
        <h1>We’re Hiring</h1>
        <h4>我们期待这样的你</h4>
        <v-collapse-group :onlyOneActive="true" class="para">
          <v-collapse-wrapper class="jobtitle" :active="true">
            <header v-collapse-toggle>
              <div class="left">
                <h3>视觉/平面设计师</h3>
                <h5>12-22k</h5>
              </div>
              <div class="right">
                <h6>上海市</h6>
                <i
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                      fill="#F2F3F5"
                    />
                    <path
                      d="M16.8 9L18 10.1667L12 16L6 10.1667L7.2 9L12 13.6667L16.8 9Z"
                      fill="#99A0B3"
                    />
                  </svg>
                </i>
              </div>
              <img
                class="illustration2"
                src="https://assets.dinlab.cn/staticPage/img/job-placehold2.png"
                alt=""
              />
            </header>
            <div class="sctall" v-collapse-content>
              <div class="sec">
                <div class="cont1">
                  <h5>我们记忆中的你，是这个样子的：</h5>
                  <p>1、有着良好的教育背景，有海外留学经验可以为你加分；</p>
                  <p>
                    2、较好的美术和设计功底，能完成日常运营和视觉类设计工作；
                  </p>
                  <p>3、有手绘功底或者C4D精通是你的加分项；</p>
                  <p>4、善于沟通，善于学习，有良好的沟通能力和团队合作能力；</p>
                  <p>5、具备敏捷高效的执行能力，快速提出解决方案并完成执行。</p>
                </div>
                <div class="cont2">
                  <h5>你所需要做的是：</h5>
                  <p>1、负责产品运营中所需要的视觉设计工作；</p>
                  <p>
                    2、负责和各类设计师（frog/奥美/星巴克等国际一线设计师）沟通，对接日常项目事务；
                  </p>
                  <p>3、和最牛的团队一起颠覆现有设计教育生态。</p>
                </div>
              </div>
              <div class="sec">
                <div class="cont1">
                  <h5>投递方式</h5>
                  <p>请将你的简历以及一段有关你的介绍</p>
                  <p>以邮件和附件的形式发送至 <b>hi@dinlab.cn</b></p>
                </div>
                <div class="cont2">
                  <h5>推荐奖励</h5>
                  <p>推荐好友入职成功</p>
                  <p>我们也会为你送上 AirPods Pro</p>
                </div>
              </div>
            </div>
          </v-collapse-wrapper>
          <v-collapse-wrapper class="jobtitle">
            <header v-collapse-toggle>
              <div class="left">
                <h3>课程助教</h3>
                <h5>8-12k</h5>
              </div>
              <div class="right">
                <h6>上海市</h6>
                <i
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                      fill="#F2F3F5"
                    />
                    <path
                      d="M16.8 9L18 10.1667L12 16L6 10.1667L7.2 9L12 13.6667L16.8 9Z"
                      fill="#99A0B3"
                    />
                  </svg>
                </i>
              </div>
              <!-- <img class="illustration2" src="https://video.dinlab.cn/images/job/job2.png" alt=""> -->
            </header>
            <div class="sctall" v-collapse-content>
              <div class="sec">
                <div class="cont1">
                  <h5>我们记忆中的你，是这个样子的：</h5>
                  <p>
                    １、有着良好的口才，性格外向活泼，喜欢一切新奇事物，爱折腾；
                  </p>
                  <p>２、善于沉淀和积累，崇尚刻意练习；</p>
                  <p>３、在校期间折腾过小项目或小社团；</p>
                  <p>
                    ４、自食其力不服输，有阅读的习惯，在意自我成长，且有明确的目标；
                  </p>
                  <p>５、熟悉各类设计软件。</p>
                </div>
                <div class="cont2">
                  <h5>你所需要做的是：</h5>
                  <p>１、协助课程团队以及讲师的各项工作；</p>
                  <p>２、管理社群，帮助更多小伙伴一起成长；</p>
                  <p>３、和最牛的团队一起颠覆现有设计教育生态。</p>
                </div>
              </div>
              <div class="sec">
                <div class="cont1">
                  <h5>投递方式</h5>
                  <p>请将你的简历以及一段有关你的介绍</p>
                  <p>以邮件和附件的形式发送至 <b>hi@dinlab.cn</b></p>
                </div>
                <div class="cont2">
                  <h5>推荐奖励</h5>
                  <p>推荐好友入职成功</p>
                  <p>我们也会为你送上 AirPods Pro</p>
                </div>
              </div>
            </div>
          </v-collapse-wrapper>
          <v-collapse-wrapper class="jobtitle">
            <header v-collapse-toggle>
              <div class="left">
                <h3>运营推广</h3>
                <h5>10-18k</h5>
              </div>
              <div class="right">
                <h6>上海市</h6>
                <i
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                      fill="#F2F3F5"
                    />
                    <path
                      d="M16.8 9L18 10.1667L12 16L6 10.1667L7.2 9L12 13.6667L16.8 9Z"
                      fill="#99A0B3"
                    />
                  </svg>
                </i>
              </div>
            </header>
            <div class="sctall" v-collapse-content>
              <div class="sec">
                <div class="cont1">
                  <h5>我们记忆中的你，是这个样子的：</h5>
                  <p>１、有着良好的语言沟通能力，分析判断能力；</p>
                  <p>２、具备文案能力，有社群运营能力者加分；</p>
                  <p>３、具备共情能力，站在用户角度思考有深刻洞察；</p>
                  <p>４、对用户需求敏感，思维活跃，逻辑清晰；</p>
                  <p>５、用户导向，价值观正，追求个人价值提升；</p>
                  <p>
                    ６、有创业心态，能承受创业团队高成长压力，愿意投入付出。
                  </p>
                </div>
                <div class="cont2">
                  <h5>你所需要做的是：</h5>
                  <p>１、协助运营团队的各项决策和活动支持；</p>
                  <p>２、参与产品推广，用户增长；</p>
                  <p>３、和最牛的团队一起颠覆现有设计教育生态。</p>
                </div>
              </div>
              <div class="sec">
                <div class="cont1">
                  <h5>投递方式</h5>
                  <p>请将你的简历以及一段有关你的介绍</p>
                  <p>以邮件和附件的形式发送至 <b>hi@dinlab.cn</b></p>
                </div>
                <div class="cont2">
                  <h5>推荐奖励</h5>
                  <p>推荐好友入职成功</p>
                  <p>我们也会为你送上 AirPods Pro</p>
                </div>
              </div>
            </div>
          </v-collapse-wrapper>
          <v-collapse-wrapper class="jobtitle">
            <header v-collapse-toggle>
              <div class="left">
                <h3>品牌商务</h3>
                <h5>12-20k</h5>
              </div>
              <div class="right">
                <h6>上海市</h6>
                <i
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                      fill="#F2F3F5"
                    />
                    <path
                      d="M16.8 9L18 10.1667L12 16L6 10.1667L7.2 9L12 13.6667L16.8 9Z"
                      fill="#99A0B3"
                    />
                  </svg>
                </i>
              </div>
            </header>
            <div class="sctall" v-collapse-content>
              <div class="sec">
                <div class="cont1">
                  <h5>我们记忆中的你，是这个样子的：</h5>
                  <p>１、有着良好的语言表达能力、判断能力，与商务拓展能力；</p>
                  <p>２、具备管理能力、计划能力及团队协作能力；</p>
                  <p>
                    ３、有自主学习能力、沟通交流能力、逻辑思维能力，并脚踏实地做好每一件事情；
                  </p>
                  <p>４、自己认可的工作；有成长，有成就感。</p>
                </div>
                <div class="cont2">
                  <h5>你所需要做的是：</h5>
                  <p>１、输出品牌帮助更多企业和设计师认识我们；</p>
                  <p>２、策划活动，以及可以让你的策划落地；</p>
                  <p>３、和最牛的团队一起颠覆现有设计教育生态。</p>
                </div>
              </div>
              <div class="sec">
                <div class="cont1">
                  <h5>投递方式</h5>
                  <p>请将你的简历以及一段有关你的介绍</p>
                  <p>以邮件和附件的形式发送至 <b>hi@dinlab.cn</b></p>
                </div>
                <div class="cont2">
                  <h5>推荐奖励</h5>
                  <p>推荐好友入职成功</p>
                  <p>我们也会为你送上 AirPods Pro</p>
                </div>
              </div>
            </div>
          </v-collapse-wrapper>
          <v-collapse-wrapper class="jobtitle">
            <header v-collapse-toggle>
              <div class="left">
                <h3>视频编导&创意策划</h3>
                <h5>12-20k</h5>
              </div>
              <div class="right">
                <h6>上海市</h6>
                <i
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                      fill="#F2F3F5"
                    />
                    <path
                      d="M16.8 9L18 10.1667L12 16L6 10.1667L7.2 9L12 13.6667L16.8 9Z"
                      fill="#99A0B3"
                    />
                  </svg>
                </i>
              </div>
            </header>
            <div class="sctall" v-collapse-content>
              <div class="sec">
                <div class="cont1">
                  <h5>我们记忆中的你，是这个样子的：</h5>
                  <p>１、逻辑能力强，讲故事能力强，可以把晦涩的内容轻松讲述，能独立创作分镜；</p>
                  <p>２、社交媒体深度用户，脑洞大，思维活跃，了解当前视频领域的热点动向，熟悉网络流行梗，具有创意思维；</p>
                  <p>３、热爱艺术设计，具有一定美感，对流行趋势高度敏感，善于捕捉一切好玩的新鲜事物；</p>
                  <p>４、了解新软件新技术，熟悉动画软件，能够配合动画创造节奏的优先；</p>
                  <p>５、学习能力强，有敬业精神，有职业目标，愿意一同探索，不断超越。</p>
                </div>
                <div class="cont2">
                  <h5>你所需要做的是：</h5>
                  <p>１、负责选题策划，根据市场动向和目标用户画像策划有价值，有内容，有意思的选题；</p>
                  <p>２、管理项目，跟踪视频项目的各方资源，输出及落地；</p>
                  <p>３、数据管理，视频内容运营策略及平台分析，分析数据，根据数据和用户反馈不断优化内容方向。</p>
                </div>
              </div>
              <div class="sec">
                <div class="cont1">
                  <h5>投递方式</h5>
                  <p>请将你的简历以及一段有关你的介绍</p>
                  <p>以邮件和附件的形式发送至 <b>hi@dinlab.cn</b></p>
                </div>
                <div class="cont2">
                  <h5>推荐奖励</h5>
                  <p>推荐好友入职成功</p>
                  <p>我们也会为你送上 AirPods Pro</p>
                </div>
              </div>
            </div>
          </v-collapse-wrapper>
          <v-collapse-wrapper class="jobtitle">
            <header v-collapse-toggle>
              <div class="left">
                <h3>动画设计师</h3>
                <h5>10-18k</h5>
              </div>
              <div class="right">
                <h6>上海市</h6>
                <i
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                      fill="#F2F3F5"
                    />
                    <path
                      d="M16.8 9L18 10.1667L12 16L6 10.1667L7.2 9L12 13.6667L16.8 9Z"
                      fill="#99A0B3"
                    />
                  </svg>
                </i>
              </div>
            </header>
            <div class="sctall" v-collapse-content>
              <div class="sec">
                <div class="cont1">
                  <h5>我们记忆中的你，是这个样子的：</h5>
                  <p>１、优秀的动画节奏感与创造力，熟悉镜头语言，掌握动画运动规律，具有用动效解决问题的创造性思维方式；</p>
                  <p>２、动画、设计类相关专业，熟练使用Ae、Ps等2D动画软件，有成熟作品，另有C4D等三维动画相关经验优先；</p>
                  <p>３、具有平面设计基础，善于探索和尝试一切好玩的视觉解决方案；</p>
                  <p>４、学习能力强，有敬业精神，有职业目标，愿意一同探索，不断超越。</p>
                </div>
                <div class="cont2">
                  <h5>你所需要做的是：</h5>
                  <p>１、协助完成宇宙电台视频动画制作设计；</p>
                  <p>２、保证动画的品质感，持续对动画质量进行总结。</p>
                </div>
              </div>
              <div class="sec">
                <div class="cont1">
                  <h5>投递方式</h5>
                  <p>请将你的简历以及一段有关你的介绍</p>
                  <p>以邮件和附件的形式发送至 <b>hi@dinlab.cn</b></p>
                </div>
                <div class="cont2">
                  <h5>推荐奖励</h5>
                  <p>推荐好友入职成功</p>
                  <p>我们也会为你送上 AirPods Pro</p>
                </div>
              </div>
            </div>
          </v-collapse-wrapper>
          <v-collapse-wrapper class="jobtitle">
            <header v-collapse-toggle>
              <div class="left">
                <h3>新媒体文案</h3>
                <h5>8-12k</h5>
              </div>
              <div class="right">
                <h6>上海市</h6>
                <i
                  ><svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
                      fill="#F2F3F5"
                    />
                    <path
                      d="M16.8 9L18 10.1667L12 16L6 10.1667L7.2 9L12 13.6667L16.8 9Z"
                      fill="#99A0B3"
                    />
                  </svg>
                </i>
              </div>
            </header>
            <div class="sctall" v-collapse-content>
              <div class="sec">
                <div class="cont1">
                  <h5>我们记忆中的你，是这个样子的：</h5>
                  <p>１、善于驾驭文字，洞察人心，讲故事能力强，有极强的概括能力，和内容延展能力；</p>
                  <p>２、对内容抱有好奇心，阅读量及观影量大，对内容有自己的理解和分析；</p>
                  <p>３、具有一定文字功底，艺术审美水平高；</p>
                  <p>４、社交媒体深度用户，脑洞大，思维活跃，熟悉网络流行梗，时常冒新点子；</p>
                  <p>５、学习能力强，有敬业精神，有职业目标，愿意一同探索，不断超越。</p>
                </div>
                <div class="cont2">
                  <h5>你所需要做的是：</h5>
                  <p>１、负责宇宙电台内容的收集、研究、攥写及复盘整理；</p>
                  <p>２、负责微信公众号视频及发文同步。</p>
                </div>
              </div>
              <div class="sec">
                <div class="cont1">
                  <h5>投递方式</h5>
                  <p>请将你的简历以及一段有关你的介绍</p>
                  <p>以邮件和附件的形式发送至 <b>hi@dinlab.cn</b></p>
                </div>
                <div class="cont2">
                  <h5>推荐奖励</h5>
                  <p>推荐好友入职成功</p>
                  <p>我们也会为你送上 AirPods Pro</p>
                </div>
              </div>
            </div>
          </v-collapse-wrapper>
        </v-collapse-group>
      </section>
      <section class="about">
        <h1>About dinlab Team</h1>
        <h4>关于dinlab团队</h4>
        <img
          class="illustration"
          src="https://assets.dinlab.cn/staticPage/img/job-placehold3.png"
          alt=""
        />
        <div class="para">
          <p>
            这个宇宙里最不受限的团队，<br />
            天马行空，满脑子理想和幻想，<br />
            不断突破界限，投入全新世界，也为更多勇于探寻自我的人创造新的体验。
          </p>
          <p>
            90后团队，扁平协作，专注的工作氛围，高效的处事风格；<br />
            无限咖啡，无限啤酒，无限零食，无限下午茶，外加一间小游戏厅，生活烦恼用美食与拳皇统统KO，正确的情绪管理也很重要；<br />
            每月团建，旅行，打球，滑板，攀登，露营，不仅探索世界，也一起更好的体验生活，认识自我；<br />
            喵星人爱好者，布偶，英短，德文，暹罗，团队伙伴一应俱全。<br />
            上海静安区南京西路地铁站上盖，坐拥繁华，交通便利，懒星人友好。
          </p>
        </div>
      </section>
      <section class="day">
        <h1>One Day in dinlab</h1>
        <h4>在dinlab的一天</h4>
        <img
          class="illustration"
          src="https://assets.dinlab.cn/staticPage/img/job-placehold4.png"
          alt=""
        />
        <div class="para">
          <div class="timeline1 left">
            <img
              class="timeline"
              src="https://assets.dinlab.cn/staticPage/img/job-timeline1.png"
              alt=""
            />
            <p>早晨伙伴们习惯一杯咖啡开启元气满满的一天</p>
            <img src="https://video.dinlab.cn/images/job/env1.jpg" alt="" />
            <svg
              width="631"
              height="295"
              viewBox="0 0 631 295"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 0C2 316.777 324.6 292.575 631 292.575"
                stroke="#F2F3F5"
                stroke-width="3"
                stroke-miterlimit="16"
              />
            </svg>
          </div>
          <div class="timeline2 right">
            <img
              class="timeline"
              src="https://assets.dinlab.cn/staticPage/img/job-timeline2.png"
              alt=""
            />
            <p>你会参加晨会，头脑风暴点燃属于你的一天</p>
            <img src="https://video.dinlab.cn/images/job/env2.jpg" alt="" />
            <svg
              width="631"
              height="295"
              viewBox="0 0 631 295"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 0C2 316.777 324.6 292.575 631 292.575"
                stroke="#F2F3F5"
                stroke-width="3"
                stroke-miterlimit="16"
              />
            </svg>
          </div>
          <div class="timeline3 left">
            <img
              class="timeline"
              src="https://assets.dinlab.cn/staticPage/img/job-timeline3.png"
              alt=""
            />
            <p>属于你的位置，专注于你的工作</p>
            <img src="https://video.dinlab.cn/images/job/env3.jpg" alt="" />
            <svg
              width="631"
              height="295"
              viewBox="0 0 631 295"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 0C2 316.777 324.6 292.575 631 292.575"
                stroke="#F2F3F5"
                stroke-width="3"
                stroke-miterlimit="16"
              />
            </svg>
          </div>
          <div class="timeline4 right">
            <img
              class="timeline"
              src="https://assets.dinlab.cn/staticPage/img/job-timeline4.png"
              alt=""
            />
            <p>疲惫的时候，可以来放松区休息一下或者安静汲取灵感</p>
            <img src="https://video.dinlab.cn/images/job/env5.jpg" alt="" />
            <svg
              width="631"
              height="295"
              viewBox="0 0 631 295"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 0C2 316.777 324.6 292.575 631 292.575"
                stroke="#F2F3F5"
                stroke-width="3"
                stroke-miterlimit="16"
              />
            </svg>
          </div>
          <div class="timeline1 left">
            <img
              class="timeline"
              src="https://assets.dinlab.cn/staticPage/img/job-timeline5.png"
              alt=""
            />
            <p>当然，如果你想找伙伴聊聊天，我们也随时都在。</p>
            <img src="https://video.dinlab.cn/images/job/env4.jpg" alt="" />
          </div>
        </div>
      </section>
    </main>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
  import { TITLE_SUFFIX } from "../constant/constant";
  import TheFooter from "../components/TheFooter";

  export default {
    name: "Job",
    components: {
      TheFooter,
    },
    created() {
      document.title = "加入我们" + TITLE_SUFFIX;
    },
  };
</script>

<style lang="scss">
  .page-job {
    background: #ffffff;
    min-height: 100vh;
    main.main-path {
      position: relative;
      padding-top: 0px;
      width: 100%;
      .path-header {
        width: 100%;
        height: 70px;
        padding: 0 calc((100vw - 1410px) / 2);
        position: fixed;
        z-index: 999;
        top: 0px;
        background: #f5f5f5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        transition: all 0.2s;
        &.show {
          opacity: 1;
        }
        .left {
          display: flex;
          justify-content: space-between;
          align-items: center;
          h2 {
            font-size: 2.6rem;
            font-weight: 300;
            margin-right: 20px;
          }
          .gridback {
            font-size: 16px;
            line-height: 16px;
            color: #99a0b2;
            letter-spacing: 1px;
            border: 0;
            border-radius: 8px;
            background: #ffffff;
            padding: 8px 12px 8px;
            vertical-align: middle;
            cursor: pointer;
            opacity: 0;
            transition: all 0.1s;
            display: flex;
            justify-content: center;
            align-items: center;
            svg {
              fill: #99a0b2;
              margin-right: 4px;
            }
            &:hover {
              background: rgba(0, 0, 0, 0.05);
              color: #42454d;
              svg {
                fill: #42454d;
              }
            }
          }
          .gridback.show {
            opacity: 1;
          }
        }
        .headerNav {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .headerNav__item {
            display: block;
            line-height: 52px;
            border-radius: 52px;
            border: 0;
            padding: 0 25px;
            font-size: 16px;
            color: #99a0b2;
            letter-spacing: 1px;
            text-align: center;
            border-left: 1px solid transparent;
            border-right: 1px solid transparent;
            background: rgba(0, 0, 0, 0);
            transition: all 0.2s;
            cursor: pointer;
          }
          .headerNav__item.headerNav__item--current {
            background: #ffffff;
            color: #42454d;
            font-weight: 800;
          }
        }
      }
      section {
        max-width: 1410px;
        margin: 0 auto;
        padding-left: calc(1410px * 0.33333);
        padding-bottom: 100px;
        position: relative;
        h1 {
          color: #ff6f61;
          font-family: "cobe-heavy";
          font-size: 56px;
          line-height: 1;
          text-transform: uppercase;
          margin-bottom: 40px;
        }
        h4 {
          position: absolute;
          font-size: 28px;
          color: #42454d;
          letter-spacing: 0.64px;
          text-align: right;
          width: 33.333%;
          left: 0;
          padding-right: 50px;
          font-weight: normal;
        }
        img.illustration {
          position: absolute;
          right: 0;
          top: 0;
          width: 10%;
          margin-right: 7%;
        }
        .para {
          width: 100%;
          padding-right: 20%;
          p {
            font-weight: 400;
            font-size: 16px;
            color: #838999;
            letter-spacing: 0.64px;
            text-align: justify;
            line-height: 32px;
            margin-bottom: 32px;
          }
        }
      }
      section.waiting {
        padding-top: 100px;
        img.illustration {
          top: 100px;
        }
        .para {
          p {
            margin-bottom: 0;
          }
          p.li {
            padding-left: 2em;
            text-indent: -2em;
          }
        }
      }
      section.hiring {
        .para {
          width: 90%;
          background: #f5f5f5;
          border: 2px solid #f5f5f5;
          border-radius: 20px;
          padding-right: 0%;
        }
        .jobtitle {
          margin-bottom: 0px;
          header {
            height: 80px;
            background: #fff;
            border-radius: 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 30px;
            margin-bottom: 2px;
            img.illustration2 {
              position: absolute;
              right: 0;
              top: -25px;
              width: 10%;
              margin-right: 7%;
            }
            .left {
              display: flex;
              justify-content: space-between;
              align-items: center;
              h3 {
                font-weight: normal;
                font-size: 26px;
                color: #42454d;
                letter-spacing: 0.72px;
                margin-right: 20px;
                font-weight: normal;
              }
              h5 {
                font-family: "cobe-heavy";
                font-size: 24px;
                color: #ff6f61;
                letter-spacing: 0.72px;
                margin-top: 6px;
              }
            }
            .right {
              display: flex;
              justify-content: space-between;
              align-items: center;
              h6 {
                font-size: 18px;
                color: #838999;
                letter-spacing: 0;
                text-align: justify;
                line-height: 32px;
                margin-right: 20px;
                font-weight: normal;
              }
              i {
                width: 26px;
                height: 26px;
              }
            }
          }
          .sec {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-top: 30px;

            .cont1 {
              flex: 4;
              padding-right: 4%;
            }
            .cont2 {
              flex: 3;
            }
            h5 {
              font-size: 18px;
              color: #42454d;
              letter-spacing: 0;
              text-align: justify;
              line-height: 32px;
              margin-bottom: 5px;
            }
            p {
              font-size: 14px;
              color: #838999;
              letter-spacing: 0;
              text-align: justify;
              line-height: 32px;
              padding-left: 2em;
              text-indent: -2em;
              margin-bottom: 0;
              text-align: left;
            }
          }
          .v-collapse-content {
            max-height: 0;
            overflow: hidden;
            transition: all 0.3s ease;
            padding: 0 30px;
            &.v-collapse-content-end {
              max-height: 700px;
              padding-bottom: 60px;
            }
          }
        }
        .vc-collapse {
        }
      }
      section.about {
      }
      section.day {
        img.illustration {
          top: -40px;
        }
        .para {
          width: 100%;
          padding-right: 10%;
          img.timeline {
            border: 0;
            width: 200px;
          }
          p {
            margin-bottom: 30px;
            font-size: 22px;
            color: #838999;
          }
          img {
            max-width: 560px;
            border: 5px solid #f5f5f5;
            border-radius: 20px;
            margin-bottom: 50px;
          }
          .left {
            position: relative;
            padding-left: 300px;
            margin-bottom: 100px;
            img.timeline {
              position: absolute;
              top: 0;
              left: 0;
            }
            svg {
              position: absolute;
              bottom: -50px;
              left: 100px;
              stroke-dasharray: 880;
              stroke-dashoffset: 880;
              animation: animL 5s ease infinite;
            }
            @keyframes animL {
              from {
                stroke-dashoffset: 880;
              }
              50% {
                stroke-dashoffset: 0;
              }
              to {
                stroke-dashoffset: -880;
              }
            }
          }
          .right {
            position: relative;
            padding-right: 300px;
            margin-bottom: 100px;
            img.timeline {
              position: absolute;
              top: 0;
              right: 0;
            }
            svg {
              position: absolute;
              bottom: -50px;
              right: 100px;
              transform: rotateY(180deg);
              stroke-dasharray: 880;
              stroke-dashoffset: 880;
              animation: animR 5s ease infinite;
            }
            @keyframes animR {
              from {
                stroke-dashoffset: 880;
              }
              50% {
                stroke-dashoffset: 0;
              }
              to {
                stroke-dashoffset: -880;
              }
            }
          }
        }
      }
    }
  }
  @media (min-width: 1230px) and (max-width: 1470px) {
    .page-job {
      main.main-path {
        max-width: 1170px;
        margin: 0 auto;
        section,
        .path-header {
          max-width: 1170px;
        }
        section {
          padding-bottom: 80px;
          padding-left: calc(1170px * 0.33333);
          h1 {
            font-size: 80px;
            letter-spacing: -1px;
          }
          h4 {
            font-size: 26px;
            padding-right: 40px;
          }
          .para {
            padding-right: 20%;
            p {
              font-size: 16px;
              line-height: 32px;
              margin-bottom: 32px;
            }
          }
        }
        section.waiting {
          padding-top: 80px;
        }
        section.hiring {
          .para {
            padding-right: 0%;
          }
          .jobtitle {
            header {
              height: 80px;
              img.illustration2 {
                position: absolute;
                right: 0;
                top: -34px;
                width: 10%;
                margin-right: 7%;
              }
              .left {
                h3 {
                  font-size: 28px;
                  letter-spacing: 0.72px;
                  margin-right: 20px;
                }
                h5 {
                  font-size: 26px;
                  letter-spacing: 0.72px;
                  margin-top: 6px;
                }
              }
              .right {
                h6 {
                  font-size: 18px;
                  line-height: 32px;
                  margin-right: 20px;
                }
                i {
                  width: 26px;
                  height: 26px;
                }
              }
            }
            .sec {
              h5 {
                font-size: 18px;
                line-height: 32px;
                margin-bottom: 5px;
              }
              p {
                font-size: 14px;
                line-height: 32px;
              }
            }
            .v-collapse-content {
              &.v-collapse-content-end {
                padding-bottom: 80px;
              }
            }
          }
        }
        section.day {
          h1 {
            font-size: 68px;
            letter-spacing: -4px;
          }
        }
      }
    }
  }
  @media (min-width: 980px) and (max-width: 1229px) {
    .page-job {
      main.main-path {
        max-width: 940px;
        margin: 0 auto;
        section,
        .path-header {
          max-width: 940px;
        }
        section {
          padding-bottom: 80px;
          padding-left: calc(940px * 0.33333);
          h1 {
            font-size: 66px;
            letter-spacing: -2px;
          }
          h4 {
            font-size: 22px;
            padding-right: 40px;
          }
          .para {
            padding-right: 10%;
            p {
              font-size: 14px;
              letter-spacing: 0.2px;
              line-height: 32px;
              margin-bottom: 32px;
            }
          }
        }
        section.waiting {
          padding-top: 80px;
        }
        section.hiring {
          .para {
            padding-right: 0%;
          }
          .jobtitle {
            header {
              height: 70px;
              img.illustration2 {
                position: absolute;
                right: 0;
                top: -8px;
                width: 14%;
                margin-right: 7%;
              }
              .left {
                h3 {
                  font-size: 22px;
                  letter-spacing: 0.72px;
                  margin-right: 20px;
                }
                h5 {
                  font-size: 22px;
                  letter-spacing: 0.72px;
                  margin-top: 6px;
                }
              }
              .right {
                h6 {
                  font-size: 14px;
                  line-height: 32px;
                  margin-right: 20px;
                }
                i {
                  width: 26px;
                  height: 26px;
                }
              }
            }
            .sec {
              h5 {
                font-size: 16px;
                line-height: 32px;
                margin-bottom: 5px;
              }
              p {
                font-size: 12px;
                line-height: 24px;
              }
            }
            .v-collapse-content {
              &.v-collapse-content-end {
                padding-bottom: 80px;
              }
            }
          }
        }
        section.day {
          h1 {
            font-size: 53px;
            letter-spacing: -2px;
          }
        }
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 979px) {
    .page-job {
      main.main-path {
        max-width: 750px;
        margin: 0 auto;
        section,
        .path-header {
          max-width: 750px;
        }
        section {
          padding-bottom: 80px;
          padding-left: calc(750px * 0.33333);
          h1 {
            font-size: 50px;
            letter-spacing: -1px;
          }
          h4 {
            font-size: 18px;
            padding-right: 30px;
          }
          .para {
            padding-right: 10%;
            p {
              font-size: 14px;
              letter-spacing: 0.2px;
              line-height: 28px;
              margin-bottom: 32px;
            }
          }
        }
        section.waiting {
          padding-top: 80px;
        }
        section.hiring {
          .para {
            padding-right: 0;
          }
          .jobtitle {
            header {
              height: 60px;
              img.illustration2 {
                position: absolute;
                right: 0;
                top: -5px;
                width: 14%;
                margin-right: 7%;
              }
              .left {
                h3 {
                  font-size: 18px;
                  letter-spacing: 0.72px;
                  margin-right: 20px;
                }
                h5 {
                  font-size: 18px;
                  letter-spacing: 0.72px;
                  margin-top: 6px;
                }
              }
              .right {
                h6 {
                  font-size: 12px;
                  line-height: 32px;
                  margin-right: 20px;
                }
                i {
                  width: 26px;
                  height: 26px;
                }
              }
            }
            .sec {
              h5 {
                font-size: 16px;
                line-height: 32px;
                margin-bottom: 5px;
              }
              p {
                font-size: 12px;
                line-height: 24px;
              }
            }
            .v-collapse-content {
              &.v-collapse-content-end {
                padding-bottom: 80px;
              }
            }
          }
        }
        section.day {
          h1 {
            font-size: 43px;
            letter-spacing: -2px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .page-job {
      background: #ffffff;
      min-height: 100vh;
      main.main-path {
        position: relative;
        width: 100%;
        padding: 0;
        padding-top: 0px;
        .path-header {
          width: 100%;
          height: 60px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.2s;
          padding-left: 20px;
          .left {
            display: flex;
            justify-content: space-between;
            align-items: center;
            h2 {
              font-size: 26px;
              font-weight: 300;
              font-family: "PingFang SC", Helvetica, Tahoma, Arial,
                "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, SimSun, 宋体,
                Heiti, 黑体, sans-serif;
              margin-bottom: 0;
            }
          }
        }
        section {
          margin: 0 auto;
          padding-bottom: 80px;
          position: relative;
          padding: 15px 15px 50px;
          h1 {
            font-size: 36px;
            line-height: 1;
            margin-bottom: 10px;
          }
          h4 {
            position: relative;
            font-size: 22px;
            letter-spacing: 0.64px;
            text-align: left;
            width: 100%;
          }
          img.illustration {
            position: absolute;
            right: 0;
            top: 0;
            width: 30%;
          }
          .para {
            width: 100%;
            margin-top: 60px;
            padding-right: 20px;
            p {
              font-weight: 400;
              font-size: 14px;
              letter-spacing: 0.2px;
              text-align: justify;
              line-height: 2;
              font-weight: 300;
            }
          }
        }
        section.waiting {
          padding-top: 50px;
          img.illustration {
            top: 100px;
          }
          .para {
            p {
              margin-bottom: 0;
            }
            p.li {
              padding-left: 2em;
              text-indent: -2em;
            }
          }
        }
        section.hiring {
          h4 {
            margin-bottom: 50px;
          }
          .para {
            width: 100%;
          }
          .jobtitle {
            &:last-child {
              margin-bottom: 0px;
            }
            header {
              height: 60px;
              border-bottom: 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 15px;
              img.illustration2 {
                position: absolute;
                right: 0;
                top: 53px;
                width: 110px;
              }
              .left {
                display: flex;
                justify-content: space-between;
                align-items: center;
                h3 {
                  font-weight: 900;
                  font-size: 18px;
                  letter-spacing: 0.72px;
                  margin-right: 10px;
                  font-weight: normal;
                  margin-bottom: 0;
                }
                h5 {
                  font-size: 16px;
                  letter-spacing: 0.72px;
                  margin-top: 3px;
                }
              }
              .right {
                display: flex;
                justify-content: space-between;
                align-items: center;
                h6 {
                  font-size: 12px;
                  letter-spacing: 0;
                  text-align: justify;
                  line-height: 32px;
                  margin-right: 10px;
                  font-weight: normal;
                }
                i {
                  width: 26px;
                  height: 26px;
                }
              }
            }
            .sec {
              margin-top: 15px;
              display: block;

              .cont1 {
                margin-bottom: 20px;
                padding-right: 0;
              }
              .cont2 {
              }
              h5 {
                font-size: 16px;
                letter-spacing: 0;
                text-align: justify;
                line-height: 32px;
                margin-bottom: 5px;
              }
              p {
                font-weight: 300;
                font-size: 12px;
                letter-spacing: 0;
                text-align: justify;
                line-height: 24px;
                padding-left: 2em;
                text-indent: -2em;
                margin-bottom: 0;
                text-align: left;
              }
            }
            .v-collapse-content {
              max-height: 0;
              overflow: hidden;
              transition: all 0.3s ease;
              padding: 0 15px;
              &.v-collapse-content-end {
                max-height: 700px;
                padding-bottom: 50px;
              }
            }
          }
        }
        section.about {
          img.illustration {
            top: 50px;
          }
        }
        section.day {
          h1 {
            font-size: 36px;
            letter-spacing: -1px;
          }
          img.illustration {
            top: 50px;
          }
          .para {
            width: 100%;
            margin-top: 80px;
            padding-right: 0;
            .left {
              padding-left: 0;
              margin-bottom: 60px;
              p {
                margin-bottom: 20px;
                padding-left: 130px;
                font-weight: normal;
                font-size: 16px;
              }
              img {
                background: #d8d8d8;
                border-radius: 8px;
                margin-bottom: 0px;
                max-width: 100%;
              }
              img.timeline {
                background: transparent;
                width: 110px;
              }
              svg {
                display: none;
              }
            }
            .right {
              padding-right: 0;
              margin-bottom: 60px;
              p {
                margin-bottom: 20px;
                padding-left: 0px;
                padding-right: 130px;
                font-weight: normal;
                font-size: 16px;
              }
              img {
                background: #d8d8d8;
                border-radius: 8px;
                margin-bottom: 0px;
                max-width: 100%;
              }
              img.timeline {
                background: transparent;
                width: 110px;
              }
              svg {
                display: none;
              }
            }
          }
        }
      }
    }
  }
</style>